<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
    <v-dialog v-model="dialog" persistent id="taskError" width="800px" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
            <v-card-title class="py-6">
                {{ language.t("TaskError.title") }}
                <v-spacer></v-spacer>
                <v-btn icon color="blue darken-1" @click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class=".text-body-1">
                {{ language.t("TaskError.contactSupport") }}
                <br>
                <br>
                {{ errorMessage }}

                <br>
                <div ref="codemirror"></div>
                <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { EditorState } from '@codemirror/state';
import { EditorView, Decoration, lineNumbers } from '@codemirror/view';
import { basicSetup } from 'codemirror';

export default {
    components: {},
    props: {
    },
    data() {
        return {
            dialog: false,
            loading: false,
            errorMessage: null,
            line: 1, // Initialize this appropriately
            filecontent: '',
            editor: null
        };
    },
    mounted: function () { },
    computed: {},
    watch: {
    },
    methods: {
        showError(data) {
            this.dialog = true;
            console.log(data)
            this.$nextTick(() => {
                if (data.result.success != true) {
                    console.log(data)
                    if (!data['file-1'])
                        data['file-1'] = "\n";
                    if (!data['file+1']) {
                        data['file+1'] = ""; data['file0'] = data['file0'].replace(/\r?\n|\r/gm, "");
                    } else {
                        data['file+1'] = data['file+1'].replace(/\r?\n|\r/gm, "");
                    }
                    
                    this.filecontent = data['file-1'] + data['file0'] + data['file+1'] + "";
                    console.log(this.filecontent)

                    if (data['file0'] !== undefined) {
                        // Utility function to get the position at the start of a line
                        function getLineStartPosition(doc, lineNo) {
                            let lineStart = 0;
                            for (let i = 0; i < lineNo; i++) {
                                lineStart += doc.line(i + 1).length + 1; // +1 for newline character
                            }
                            return lineStart;
                        }

                        // The line number you want to decorate (1-based index)
                        const lineNoToDecorate = 2;

                        // Get the position for the start of the line
                        const lineStartPos = getLineStartPosition(EditorState.create({ doc: this.filecontent }).doc, lineNoToDecorate - 1);


                        // Define the custom decoration for the first line
                        const firstLineErrorDecoration = Decoration.line({
                            attributes: { class: 'cm-line-error' }
                        });

                        // Create a decoration set and add the first line decoration
                        const decorations = Decoration.set([firstLineErrorDecoration.range(lineStartPos)]);

                        const editorState = EditorState.create({
                            extensions: [
                                basicSetup,
                                EditorView.editable.of(false),
                                EditorView.decorations.of(decorations),
                                lineNumbers({ formatNumber: (lineNo) => (lineNo + data.line - 2).toString() }),
                            ],
                            doc: this.filecontent,
                        })

                        // Initialize the editor
                        this.editor = new EditorView({
                            state: editorState,
                            parent: this.$refs.codemirror
                        });

                        console.log(this.editor);
                        this.errorMessage = data.result.log[data.result.log.length - 1];
                        if (data.result.log.length > 1 && data.result.log[data.result.log.length - 2].startsWith('error:'))
                            this.errorMessage = data.result.log[data.result.log.length - 2];
                    }
                }
            })
        },
        close() {
            if (this.editor) {
                this.editor.destroy();
                this.editor = null;
            }
            this.dialog = false;
            // this.$emit('close'); // dont close task on closing dialog
        }
    },
};
</script>
<style>
/** can not be scoped */
.cm-activeLineGutter {
    background-color: #ffffff00 !important;
}

.cm-activeLine {
    background-color: #ffffff00 !important;
}

.cm-line-error {
    background: #FBC2C4 !important;
    color: #8a1f11 !important;
}
</style>